import { browserOnly } from './browserOnly';

/** Check if the browser is Chrome on IOS */
export function isChromeOnIos() {
  return browserOnly(
    window => {
      const ua = window.navigator.userAgent;
      const isIos = /iPad|iPhone|iPod/.test(ua);
      const isChrome = /CriOS/.test(ua);
      const isGsa = /GSA/.test(ua); // Google Search App
      return (isChrome || isGsa) && isIos;
    },
    () => false
  );
}
